import React from "react";
import styles from "../../LocationForm.module.css";
import {
    LocationFormSelectionProvider,
    LocationRequest,
    LocationRequestPartial,
    WorkingHoursRequest
} from "../../LocationForm";
import {ValidationResult} from "../../../../../../elements/validator/component/ValidationComponent";
import {Section} from "../../../../../../elements/section/Section";
import {ValidatedChipInputField} from "../../../../../../elements/validator/component/ValidatedChipInputField";
import {MultipleEmailValidator} from "../../../../../../elements/validator/Validator";
import {
    CustomSwitchFieldWithTitle
} from "../../../../../../elements/customSwitchFieldWithTitle/CustomSwitchFieldWithTitle";

interface Props<T, W> {
    getMessage: (s: any) => any;
    updateRequest: (update: LocationRequestPartial) => void;
    selectionProvider: LocationFormSelectionProvider<W>;
    updateValidationStatus: (status: ValidationResult<T>) => void;
}

export const LocationEmailInformation = <
    T extends LocationRequest,
    W extends WorkingHoursRequest
>({
      getMessage,
      updateRequest,
      selectionProvider,
      updateValidationStatus,
  }: Props<T, W>) => {

    return <Section title={"Location Transcript Notifications"}>
        <div className={styles.fieldsLine}>
            <ValidatedChipInputField<T>
                required={false}
                onChange={(v) => updateRequest({locationEmailTranscriptRecipients: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'locationEmailTranscriptRecipients'}
                selector={selectionProvider.locationEmailTranscriptRecipients}
                validator={MultipleEmailValidator}
                label={'Transcript Recipient(s)'}
                placeholder={"example@mail.com"}
                getMessage={getMessage}
            />
        </div>
        <CustomSwitchFieldWithTitle
            textOnTrue={"On"}
            textOnFalse={"Off"}
            title={"Transcripts Filtration"}
            description={"Only chats with a stored user email or phone number will be sent"}
            valueSelector={selectionProvider.locationEmailFiltrationEnabled}
            toggleValue={(v) => updateRequest({locationEmailFiltrationEnabled: v})}
        />
        <CustomSwitchFieldWithTitle
            textOnTrue={"On"}
            textOnFalse={"Off"}
            title={"Transcript Summary"}
            description={"Generate summary for location transcripts when trigger tools are used"}
            valueSelector={selectionProvider.locationEmailTranscriptSummaryEnabled}
            toggleValue={(v) => updateRequest({locationEmailTranscriptSummaryEnabled: v})}
        />
    </Section>
}
